export function resolveProductIdFromLine(data) {
    return data?.idproduct ?? data?.idProduct ?? data?.idproducto ?? null;
}
